/* eslint-disable camelcase */
export default {
  tee: {
    "xs": `44`,
    "s": `46`,
    "m": `48`,
    "l": `50`,
    "xl": `52`,
    "2xl": `54-56`,
    "3xl": `58-60`
  },
  classic_polo_shirt: {
    "xs": `42-44`,
    "s": `44-46`,
    "m": `46-48`,
    "l": `48-50`,
    "xl": `50-52`,
    "2xl": `52-54`
  },
  classic_tee: {
    "s": `44-46`,
    "m": `46-48`,
    "l": `48-50`,
    "xl": `50-52`,
    "2xl": `52-54`,
    "3xl": `54-56`
  },
  classic_woman_tee: {
    "s": `42-44`,
    "m": `44-46`,
    "l": `48`,
    "xl": `50`,
    "2xl": `52`
  },
  full_print_hoodie: {
    "xs": `42-44`,
    "s": `44-46`,
    "m": `48-50`,
    "l": `50-52`,
    "xl": `52-54`,
    "2xl": `54-56`,
    "3xl": `58-60`
  },
  full_print_man_polo: {
    "xs": `44`,
    "s": `46`,
    "m": `48`,
    "l": `50`,
    "xl": `52`,
    "2xl": `54`,
    "3xl": `56`,
    "4xl": `58`,
    "5xl": `60`,
    "6xl": `62`
  },
  full_print_pencil_skirt: {
    "2xs": `40`,
    "xs": `42`,
    "s": `44`,
    "m": `46`,
    "l": `48`,
    "xl": `50`,
    "2xl": `52`
  },
  full_print_skirt: {
    xs: `42`,
    s: `44`,
    m: `46`,
    l: `48`
  },
  full_print_summer_dress: {
    "2xs": `40`,
    "xs": `42`,
    "s": `44`,
    "m": `46`,
    "l": `48`,
    "xl": `50`
  },
  full_print_sweatshirt: {
    "xs": `42-44`,
    "s": `44-46`,
    "m": `48-50`,
    "l": `50-52`,
    "xl": `52-54`,
    "2xl": `54-56`,
    "3xl": `58-60`
  },
  full_print_tanktop: {
    "xs": `44`,
    "s": `46`,
    "m": `48`,
    "l": `50`,
    "xl": `52`,
    "2xl": `54`,
    "3xl": `56`,
    "4xl": `58`,
    "5xl": `60`
  },
  full_print_tee: {
    "xs": `44`,
    "s": `46`,
    "m": `48`,
    "l": `50`,
    "xl": `52`,
    "2xl": `54`,
    "3xl": `56`
  },
  full_print_woman_hoodie: {
    "s": `42-44`,
    "m": `46-50`,
    "l": `52-54`,
    "xl": `56-60`,
    "2xl": `60-64`
  },
  full_print_woman_polo: {
    "2xs": `40`,
    "xs": `42`,
    "s": `44`,
    "m": `46`,
    "l": `48`,
    "xl": `50`,
    "2xl": `52`,
    "3xl": `54`,
    "4xl": `56`,
    "5xl": `58`
  },
  full_print_woman_sweatshirt: {
    "xs": `42`,
    "s": `44`,
    "m": `46`,
    "l": `48`,
    "xl": `50`,
    "2xl": `52`
  },
  full_print_woman_tanktop: {
    "xs": `42`,
    "s": `44`,
    "m": `46`,
    "l": `48`,
    "xl": `50`,
    "2xl": `52`,
    "3xl": `54`,
    "4xl": `56`,
    "5xl": `58`
  },
  full_print_woman_tee: {
    "2xs": `40`,
    "xs": `42`,
    "s": `44`,
    "m": `46`,
    "l": `48`,
    "xl": `50`,
    "2xl": `52`,
    "3xl": `54`
  },
  leggings: {
    xs: `40`,
    s: `42`,
    m: `44`,
    l: `46`
  },
  long_sleeve_dress: {
    "2xs": `40`,
    "xs": `42`,
    "s": `44`,
    "m": `46`,
    "l": `48`,
    "xl": `50`
  },
  longsleeve: {
    "s": `44-46`,
    "m": `46-48`,
    "l": `48-50`,
    "xl": `50-52`,
    "2xl": `52-54`
  },
  man_bomber: {
    "xs": `44`,
    "s": `46`,
    "m": `48`,
    "l": `50`,
    "xl": `52`,
    "2xl": `54`,
    "3xl": `56`,
    "4xl": `58`,
    "5xl": `60`
  },
  man_pajama_pants: {
    "xs": `42-44`,
    "s": `44-46`,
    "m": `48-50`,
    "l": `50-52`,
    "xl": `52-54`,
    "2xl": `54-56`,
    "3xl": `58-60`
  },
  man_stretch_tee: {
    "s": `44-46`,
    "m": `46-48`,
    "l": `48-50`,
    "xl": `50-52`,
    "2xl": `52-54`
  },
  man_underpants: {
    "s": `44-46`,
    "m": `48-50`,
    "l": `50-52`,
    "xl": `52-54`,
    "2xl": `54-56`
  },
  paired_tee: {
    man: {
      "s": `44-46`,
      "m": `46-48`,
      "l": `48-50`,
      "xl": `50-52`,
      "2xl": `52-54`,
      "3xl": `54-56`
    },
    woman: {
      "s": `42-44`,
      "m": `44-46`,
      "l": `48`,
      "xl": `50`,
      "2xl": `52`
    }
  },
  pleated_skirt: {
    "2xs": `40`,
    "xs": `42`,
    "s": `44`,
    "m": `46`,
    "l": `48`
  },
  sleeveless_dress: {
    "2xs": `40`,
    "xs": `42`,
    "s": `44`,
    "m": `46`,
    "l": `48`,
    "xl": `50`
  },
  sweatshirt: {
    "xs": `44-46`,
    "s": `46-48`,
    "m": `48-50`,
    "l": `50-52`,
    "xl": `52-54`,
    "2xl": `54-56`
  },
  woman_bomber: {
    "2xs": `40`,
    "xs": `42`,
    "s": `44`,
    "m": `46`,
    "l": `48`,
    "xl": `50`,
    "2xl": `52`
  },
  woman_pajama_pants: {
    "xs": `42`,
    "s": `44`,
    "m": `46`,
    "l": `48`,
    "xl": `50`,
    "2xl": `52`
  },
  woman_underpants: {
    "xs": `42`,
    "s": `44`,
    "m": `46`,
    "l": `48`,
    "xl": `50`,
    "2xl": `52`
  }
};
